var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#ACACAC",
  strokeLinecap: "square",
  strokeWidth: 1.6,
  d: "M28.48 8.754a4.18 4.18 0 0 1 2.954 1.225h0a4.176 4.176 0 0 1 0 5.91l-.96.96L24 23.322l-7.434-7.435a4.179 4.179 0 0 1 5.91-5.909L24 11.504l.565-.566.96-.959a4.18 4.18 0 0 1 2.955-1.225Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M22.496 31.08v3.545h1.406v.772h-1.406v4.433h-.918v-8.75zm-6.865 2.129v-.762h2.158v-1.25h.928v1.25h2.1v.762zm.45 2.676c0-1.192.917-2.032 2.177-2.032 1.255 0 2.173.84 2.178 2.032-.005 1.2-.923 2.036-2.178 2.04-1.26-.004-2.178-.84-2.178-2.04m.888 0c-.005.762.542 1.27 1.289 1.26.742.01 1.284-.498 1.289-1.26-.005-.747-.547-1.265-1.29-1.27-.746.005-1.293.523-1.288 1.27m14.453-.147v.742h-6.094v-4.677h6.006v.752h-5.068v1.181h4.882v.733h-4.882v1.27zm-7.1 2.989v-.762h8.008v.762z"
})));
export default SvgIconHeartText;